import Select from "../../../../components/shared/Select/Select";
import React from "react";

import { ironsClub, driversClub } from "../../constants/clubs";
import { useSwingLibraryStore } from "../../store/swingLibraryStore";
import { SelectClub } from "./components/SelectClub";
import SelectDateRange from "./components/SelectDateRange";
import SelectGolfers from "./components/SelectGolfers";
import { SelectTags } from "./components/SelectTags";
import { useSwingLibrarySettings } from "../../hooks/useSwingLibrarySettings";
import { useUserData } from "../../../../hooks/useUserData";
import { listOfSubscriptions } from "../../../../common/envConfig";

const FiltersRow = () => {
  const { userData } = useUserData();
  const isPlayerPlus =
    userData?.subscriptionType === listOfSubscriptions.PLAYER_PLUS_ANNUALLY ||
    userData?.subscriptionType === listOfSubscriptions.PLAYER_PLUS_MONTHLY;
  const isAdmin = userData?.role === "admin";

  const { activeFilters, resetPagination, setActiveFilters } =
    useSwingLibraryStore();

  const { data: swingLibrarySettings } = useSwingLibrarySettings();

  const handleFilterChange = (change) => {
    switch (change.type) {
      case "analyzed":
        if (typeof change.value !== "boolean") break;
        setActiveFilters({
          analyzed:
            activeFilters.analyzed === change.value ? null : change.value,
        });
        break;
      case "cameraAngle":
        if (change.value !== "DTL" && change.value !== "FON") break;
        setActiveFilters({
          cameraAngle:
            activeFilters.cameraAngle === change.value ? null : change.value,
        });
        break;
      case "club":
        setActiveFilters({ club: change.value });
        break;
      case "date":
        setActiveFilters({ date: change.value ?? null });
        break;
      case "dominantHand":
        if (change.value !== "Left" && change.value !== "Right") break;
        setActiveFilters({
          dominantHand:
            activeFilters.dominantHand === change.value ? null : change.value,
        });
        break;
      case "tags": {
        const value = change.value;
        setActiveFilters({
          tags: Array.isArray(value)
            ? value
            : activeFilters.tags.includes(value)
            ? activeFilters.tags.filter((tag) => tag !== value)
            : [...activeFilters.tags, value],
        });
        break;
      }
      case "users": {
        const golfer = change.value;
        const exists = activeFilters.users.some(
          (u) => u.userId === golfer.userId
        );
        setActiveFilters({
          users: exists
            ? activeFilters.users.filter((u) => u.userId !== golfer.userId)
            : [...activeFilters.users, golfer],
        });
        break;
      }
      default:
        break;
    }
    resetPagination();
  };

  return (
    <>
      {!(isPlayerPlus && !isAdmin) && (
        <SelectGolfers
          header="Golfers"
          onOptionSelect={(value) =>
            handleFilterChange({ type: "users", value })
          }
          placeholder="Golfer"
          values={activeFilters.users}
        />
      )}

      <SelectDateRange
        onChange={(value) => handleFilterChange({ type: "date", value })}
        onClear={() => handleFilterChange({ type: "date", value: null })}
        placeholder="Date"
        values={activeFilters.date}
      />

      <SelectClub
        onChange={(value) => handleFilterChange({ type: "club", value })}
        options={[
          {
            label: "Woods & Hybrids",
            options: driversClub.map((club) => ({ text: club, value: club })),
          },
          {
            label: "Irons & Wedges",
            options: ironsClub.map((club) => ({ text: club, value: club })),
          },
        ]}
        placeholder="Club"
        values={activeFilters.club}
      />

      <Select
        header="Camera Angles"
        menuClassName="w-[200px]"
        onChange={(value) =>
          handleFilterChange({ type: "cameraAngle", value: value })
        }
        options={[
          { text: "Face On", value: "FON" },
          { text: "Down the Line", value: "DTL" },
        ]}
        placeholder="Camera Angle"
        value={activeFilters.cameraAngle}
        withCheckbox
      />

      <Select
        header="Status"
        menuClassName="w-[200px]"
        onChange={(value) =>
          handleFilterChange({ type: "analyzed", value: value })
        }
        options={[
          { text: "Analyzed", value: true },
          { text: "Not Analyzed", value: false },
        ]}
        placeholder="Status"
        value={activeFilters.analyzed}
        withCheckbox
      />

      <SelectTags
        header="Tags"
        onChange={(value) => handleFilterChange({ type: "tags", value: value })}
        onClear={() => handleFilterChange({ type: "tags", value: [] })}
        options={swingLibrarySettings?.tags ?? []}
        placeholder="Tags"
        values={activeFilters.tags}
      />

      <Select
        header="Dominant Hand"
        menuClassName="w-[200px]"
        onChange={(value) =>
          handleFilterChange({ type: "dominantHand", value: value })
        }
        options={[
          { text: "Left Hand", value: "Left" },
          { text: "Right Hand", value: "Right" },
        ]}
        placeholder="Filters"
        value={activeFilters.dominantHand}
        withCheckbox
      />
    </>
  );
};

export default FiltersRow;
